import { Box, Flex } from '@chakra-ui/react'
import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon
} from '@heroicons/react/16/solid'
import { Button, TextOverflow } from '@sequencehq/core-components'
import {
  GreyGrey60,
  Lato12Bold,
  Lato12Regular
} from '@sequencehq/design-tokens'
import { ReactNode } from 'react'

const linkStyling = (showLink: boolean) => ({
  transition: 'opacity 0.15s ease-in-out',
  color: GreyGrey60,
  ...Lato12Bold,
  alignItems: 'center',
  padding: '8px',
  gap: '8px',
  opacity: showLink ? 1 : 0,
  cursor: showLink ? 'pointer' : 'default',
  pointerEvents: showLink ? ('all' as const) : ('none' as const)
})

export const LeftLink = ({
  showLink,
  onClick,
  label,
  description
}: {
  showLink: boolean
  onClick: () => void
  label: string
  description?: ReactNode
}) => {
  return (
    <Flex {...linkStyling(showLink)} onClick={onClick}>
      <Button
        variant="ghost"
        icon={
          <ArrowLongLeftIcon height="16px" width="16px" color={GreyGrey60} />
        }
        aria-label="left-arrow"
      />
      <Flex flexDirection="column" alignItems="flex-start" gap="4px">
        <TextOverflow>{label}</TextOverflow>
        {description && (
          <Box
            {...Lato12Regular}
            color={GreyGrey60}
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            maxWidth="250px"
          >
            {description}
          </Box>
        )}
      </Flex>
    </Flex>
  )
}

export const RightLink = ({
  showLink,
  onClick,
  label,
  description
}: {
  showLink: boolean
  onClick: () => void
  label: string
  description?: ReactNode
}) => {
  return (
    <Flex
      {...linkStyling(showLink)}
      justifyContent="flex-end"
      onClick={onClick}
    >
      <Flex flexDirection="column" alignItems="flex-end" gap="4px">
        <TextOverflow>{label}</TextOverflow>
        {description && (
          <Box
            {...Lato12Regular}
            color={GreyGrey60}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {description}
          </Box>
        )}
      </Flex>
      <Button
        variant="ghost"
        icon={
          <ArrowLongRightIcon height="16px" width="16px" color={GreyGrey60} />
        }
        aria-label="right-arrow"
      />
    </Flex>
  )
}
